module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-16.4a89638c.png";